<script>
	import { Col, Row, Table } from "@sveltestrap/sveltestrap";
	import PageHeader from "../../../components/PageHeader/PageHeader.svelte";
	export let dataCar = [];
</script>

<Row class="my-3">
	<Col xs={6}>
		<PageHeader title="Vehicles" />
	</Col>
</Row>
<Row class="my-3 ms-3">
	<Table responsive hover>
		<thead>
			<tr>
				<th>Plate Number</th>
				<th>Make</th>
				<th>Model</th>
				<th>Status</th>
			</tr>
		</thead>
		<tbody>
			{#each dataCar as { plateNumber, vehicleMakeName, vehicleModelName, status }}
				<tr>
					<td>{plateNumber}</td>
					<td>{vehicleMakeName}</td>
					<td>{vehicleModelName}</td>
					<td>
						{#if status}
							<p class="status-bar status-bar-1">Active</p>
						{:else}
							<p class="status-bar status-bar-3">Inactive</p>
						{/if}
					</td>
				</tr>
			{/each}
			{#if dataCar.length === 0}
				<tr>
					<td colspan="4" class="text-center">No data to display</td>
				</tr>
			{/if}
		</tbody>
	</Table>
</Row>

<style>
	:global(.table > :not(:first-child)) {
		border-top: 0;
	}
</style>
